import { ILoginAccountTypes } from "@domains/features/LoginFlow/entities/CommonLoginData";
import ToggleSwitch from "@frameworks/web/components/generic/SwitchButton/Switch";
import React from "react";
const ComeqToggleBtn = (props) => {
    return props.showCOMEQTOGGLE ? (React.createElement("div", { className: `d-flex gap-1 txn-comeq  txt_blackOne1 DMSans_16_500 ` },
        React.createElement("span", { className: `${props.COMEQTOGGLE === ILoginAccountTypes.EQ &&
                "txt-midnight-blue DMSan_16_700"}` }, "Equity"),
        React.createElement("span", null,
            React.createElement(ToggleSwitch, { id: "ComEq", name: "ComEq", checked: props.COMEQTOGGLE === ILoginAccountTypes.EQ ? false : true, small: true, onChange: (checked) => {
                    if (checked) {
                        props.setCOMEQTOGGLE(ILoginAccountTypes.CO);
                    }
                    else
                        props.setCOMEQTOGGLE(ILoginAccountTypes.EQ);
                } })),
        React.createElement("span", { className: props.COMEQTOGGLE === ILoginAccountTypes.CO &&
                "txt-midnight-blue DMSan_16_700" }, "Commodity"))) : (React.createElement(React.Fragment, null));
};
export default ComeqToggleBtn;
